var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expose)?_c('div',{staticClass:"container-fixed"},[_c('div',{staticClass:"cookie-container"},[_vm._t("default"),_c('div',[_c('ci-button',{on:{"click":_vm.cookiesLGPD}},[_vm._v("Ok")])],1)],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }